/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OAuthBindCodeExchangeResVo } from './OAuthBindCodeExchangeResVo';
import {
    OAuthBindCodeExchangeResVoFromJSON,
    OAuthBindCodeExchangeResVoFromJSONTyped,
    OAuthBindCodeExchangeResVoToJSON,
    OAuthBindCodeExchangeResVoToJSONTyped,
} from './OAuthBindCodeExchangeResVo';

/**
 * 
 * @export
 * @interface ResponseOAuthBindCodeExchangeResVo
 */
export interface ResponseOAuthBindCodeExchangeResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseOAuthBindCodeExchangeResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseOAuthBindCodeExchangeResVo
     */
    message?: string;
    /**
     * 
     * @type {OAuthBindCodeExchangeResVo}
     * @memberof ResponseOAuthBindCodeExchangeResVo
     */
    data?: OAuthBindCodeExchangeResVo;
}

/**
 * Check if a given object implements the ResponseOAuthBindCodeExchangeResVo interface.
 */
export function instanceOfResponseOAuthBindCodeExchangeResVo(value: object): value is ResponseOAuthBindCodeExchangeResVo {
    return true;
}

export function ResponseOAuthBindCodeExchangeResVoFromJSON(json: any): ResponseOAuthBindCodeExchangeResVo {
    return ResponseOAuthBindCodeExchangeResVoFromJSONTyped(json, false);
}

export function ResponseOAuthBindCodeExchangeResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseOAuthBindCodeExchangeResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : OAuthBindCodeExchangeResVoFromJSON(json['data']),
    };
}

export function ResponseOAuthBindCodeExchangeResVoToJSON(json: any): ResponseOAuthBindCodeExchangeResVo {
    return ResponseOAuthBindCodeExchangeResVoToJSONTyped(json, false);
}

export function ResponseOAuthBindCodeExchangeResVoToJSONTyped(value?: ResponseOAuthBindCodeExchangeResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': OAuthBindCodeExchangeResVoToJSON(value['data']),
    };
}

